<template>
  <div @click="openImg">
    <el-upload
      class="pic-uploader-component"
      :disabled="disabled"
      :headers="{
        'x-oss-security-token': ossData.security_token
      }"
      :action="fileBaseUrl"
      :show-file-list="false"
      :data="{
        ...ossData
      }"
      :on-success="handleUploadSuccess"
    >
      <div v-if="value" class="viewImg">
        <div class="btn">
          <i class="el-icon-refresh deleteBtn"></i>
          <i class="el-icon-download deleteBtn" @click="downloadImg()"></i>
        </div>
        <img :src="this.fileBaseUrl + '/' + value" class="pic" />
      </div>

      <div v-else class="upBlock">
        <i class="el-icon-plus pic-uploader-icon"></i>
      </div>
    </el-upload>
    <el-dialog :visible.sync="visible" :append-to-body="visible">
      <img width="100%" :src="value" alt />
    </el-dialog>
  </div>
</template>
  
  <script>
import { Base64 } from "js-base64";
import { encode, decode } from "js-base64";
import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      fileBaseUrl: "",
      baseUrl: "",
      lang: localStorage.getItem("lang") || "zh_CN",
      visible: false,
      ossData: "",
      temp: "",
    };
  },
  props: {
    value: {
      default: "",
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  mounted() {
    // this.getTemp();
    this.getOss();
  },
  methods: {
    downloadImg() {
      window.open(this.value);
    },
    // 图片上传
    handleUploadSuccess(response, file, fileList) {
      let data = this.ossData.key;
      this.getTemp();
      console.log(data)
      this.$emit("input", data);
    },
    openImg() {
      if (this.disabled) {
        this.visible = true;
      }
    },
    getTemp() {
      const date = new Date();
      this.temp = date.getTime();
    },
    getOss() {
      const date = new Date();
      this.temp = date.getTime();
      this.$request.getOss({
        fileName:this.temp
      }).then((res) => {
        this.fileBaseUrl = res.data.uploadUrl
        this.ossData = res.data.formData
      });
    },
  },
};
</script>
  
  <style scoped>
.pic-uploader-component .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.pic-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.pic {
  width: 178px;
  height: 178px;
  display: block;
}
.pic-uploader-component .el-upload:hover {
  border-color: #409eff;
}
.upBlock {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
.viewImg {
  position: relative;
}
.btn {
  position: absolute;
  left: 0;
  right: 0px;
  bottom: 0;
  top: 0px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  transition: 0.5s;
}

.btn:hover {
  background-color: rgba(0, 0, 0, 0.685);
}
.deleteBtn {
  font-size: 36px;
  color: #8c939da6;
  transition: 0.5s;
}

.deleteBtn:hover {
  color: #409eff;
  transform: scale(2);
}
</style>
  


// WEBPACK FOOTER //
// src/components/upImg.vue